import { ReactElement } from "react";
import { useRenderManager } from "../../useRenderManager";
import { BirthdayLiveTileContent } from "./BirthdayLiveTileContent";
import { AppType } from "client/Api/Apps/common";
import { TileRenderState } from "../../RenderState/common";
import { TileContextProvider } from "../../TileContextProvider";
import { Coordinate } from "client/Misc/commonTypes";

export type BirthdayTileContentProps = {
	renderState: TileRenderState<AppType.Birthday>;
	onOpenTileMenu: (coordinate: Coordinate) => void;
};

export const BirthdayTileContent = (props: BirthdayTileContentProps): ReactElement => {
	const {
		renderState,
		onOpenTileMenu
	} = props;

	const { dimension } = renderState;

	const tileContent: ReactElement = useRenderManager(
		dimension,
		() => (
			<BirthdayLiveTileContent onOpenTileMenu={onOpenTileMenu} />
		)
	);

	return (
		<TileContextProvider
			renderState={renderState}
		>
			{tileContent}
		</TileContextProvider>
	);
};
BirthdayTileContent.displayName = "BirthdayTileContent";
